import asyncRoutes from '@/router/routes.js'
/**
 * 将menu对象格式化，抽取需要的参数
 * @param menu [Array]
 * @return fmMenu [Array]
 */
export function menuFormat(menu, parentUrl='') {
  // 检查参数是否可以处理
  if (!(menu instanceof Array)) {
    return false
  }

  // 处理后的容器
  let fmMenu = []

  menu.forEach(menu => {
    // console.log(menu)
    let {cur,children} = menu
    let realPath = parentUrl + cur.url
    // 递归子菜单
    if (children && children instanceof Array) {
      children = menuFormat(children, realPath)
    }

    let menuItem  = {
      path: realPath,
      name: cur.name,
      icon: cur.icon,
      children: children,
    }

    fmMenu.push(menuItem)
  })

  return fmMenu
}

export function menu2routes(menu) {
  // 检查参数是否可以处理
  if (!(menu instanceof Array)) {
    return []
  }

  // 处理后的容器
  let result = []
  menu.forEach(menu => {
    let {path, icon, name, children} = menu
    if (children && children instanceof Array) {
      // 非根节点,递归获取节点
      children = menu2routes(children)
    }

    if(path==="/car"){
        let dataMonitor=asyncRoutes['/car/dataMonitor'];
		let dataMonitorInfo=asyncRoutes['/car/dataMonitorInfo'];
        dataMonitor.meta={
            icon:'',
            name:'数据监控',
            path:'/car/dataMonitor'
        };
		dataMonitorInfo.meta={
		    icon:'',
		    name:'数据监控详情',
		    path:'/car/dataMonitorInfo'
		};
        children.push(dataMonitor);
		children.push(dataMonitorInfo);
    }

    let routeItem = {}

    // if (asyncRoutes[path]) {
      routeItem = asyncRoutes[path]
    // } else {
    //   routeItem.component = asyncRoutes['layout']()
    //   routeItem.path = path
    // }

    routeItem.meta = {
      path,
      // name,
      icon
    }

    routeItem.children = children

    result.push(routeItem)
  })
  return result
}
